module.exports = __webpack_public_path__ + "img/pbl02_19.5851bce6.jpg";